/**
 * Centralized branding configuration for white-labeling.
 * Swap brands at build time via the `beacon` Angular build configuration,
 * which fileReplacements this module with brand.config.beacon.ts.
 */
import { BrandConfig } from './brand-config.model';

const appName = 'Control Station';

export const BRAND: BrandConfig = {
  appName,
  logoPath: '/icons/appiconfg.svg',
  faviconPath: '/icons/appiconfg.svg',
  iconBasePath: '/icons/',
  deviceDisplayName: appName,
  loginCtaText: 'Log in to Vigilant',
  inviteShareTitle: 'Join my Go Vigilant group',
  inviteShareText: (code: string) => `Use this Go Vigilant invite code to join my group: ${code}`,
  accountNotLinkedMessage: "You're signed in, but this login isn't linked to a Vigilant account yet.",
  commsBlockedMessage: 'Unable to communicate with the Vigilant system, please check data connectivity.',
  versionLabel: 'Vigilant version',
};
